/* Flat-rate display helpers. Checkout shipping rates are configured in Shopify. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.VoltlinkDelivery = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  const base = Object.freeze({latitude: 51.5774184, longitude: -2.9949728});
  const standardRate = 1995;
  function deliveredTotal(subtotal, quantity = 1) {
    if (!Number.isSafeInteger(subtotal) || subtotal < 0 || !Number.isSafeInteger(quantity) || quantity < 1) return null;
    const total = subtotal * quantity + standardRate;
    return Number.isSafeInteger(total) ? total : null;
  }
  return Object.freeze({base, standardRate, deliveredTotal});
});
